
const ignoreList = [
    'essencehealthcare.com',
    'everythingessence.com',
    'lumeris.io',
    'essence-ipc.destinationrx.com',
    '362392.fs1.hubspotusercontent-na1.net'
];

const customConfirmationsList = [];

export function getConfirmLinkMessage(url) {
    if (typeof url == 'undefined') {
        return null;
    }

    const link = new URL(url);
    const messageText = TG?.externalLinkConfirmDefault ?? '';
    let message = `${messageText} ${link}\n`;

    for (let i in customConfirmationsList) {
        if (customConfirmationsList[i].hosts.indexOf(link.hostname) !== -1) {
            message = customConfirmationsList[i].message;
            break;
        }
    }

    return message;
}

function isIgnoredLink(url) {
    return ignoreList.some((ignoredDomain) => {
        return url.hostname.endsWith(ignoredDomain);
    });
}

function isCurrentHost(url) {
    return (url.hostname == window.location.hostname) ? true : false;
}

function isJSLink(url) {
    return (url.protocol === 'javascript:') ? true : false;
}

function isTelLink(url) {
    return (url.protocol === 'tel:') ? true : false;
}

function isSmsLink(url) {
    return (url.protocol === 'sms:') ? true : false;
}

function isEmailLink(url) {
    return (url.protocol === 'mailto:') ? true : false;
}

function isGoogleMapsLink(url) {
    return url.href.startsWith('https://www.google.com/maps/');
}

(($) => {
    window.addEventListener('load', init);

    function init() {
        bind();
    }

    function bind() {
        $('body').on('click', onBodyClick);
    }

    function onBodyClick(event) {

        if (!event || !(event.originalEvent instanceof Event)) {
            return true;
        }

        const $target = $(event.target);
        const el = $target.get(0);

        if (el.tagName !== 'A' || $target.is('#google_translate_element a, a[data-toggle="tab"], a[data-dt-idx]')) {
            return true;
        }

        if ($target.attr('href') == '' || $target.attr('href') == '#') {
            return true;
        }

        const url = new URL(el.href ?? window.location.href);

        if (isCurrentHost(url) || isTelLink(url) || isEmailLink(url) || isSmsLink(url) || isGoogleMapsLink(url) || isIgnoredLink(url)) {
            return true;
        }

        const messageText = (typeof TG !== 'undefined' && typeof TG.externalLinkConfirmDefault !== 'undefined') ? TG.externalLinkConfirmDefault : 'By clicking this link you will be leaving our website and taken to:';
        let message = `${messageText} ${el.href}\n`;

        for (let i in customConfirmationsList) {
            if (customConfirmationsList[i].hosts.indexOf(el.hostname) !== -1) {
                message = customConfirmationsList[i].message;
                break;
            }
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'external_link_click' }}));

        if (confirm(message)) {
            return true;
        }

        event.preventDefault();
        return true;
    }
    
})(jQuery);
